import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import thunk from "redux-thunk";
import { reducers } from "./reducers";


export default function configureStore(history, initialState) {
    // Middleware : intercepts actions before they reach the store
    const middleware = [thunk];

    // Integrate Redux DevTools if it available in browser
    const devToolsExtension
    = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__
        ? window.__REDUX_DEVTOOLS_EXTENSION__()
        : (f) => f;

    const store = createStore(
        buildRootReducer(reducers, history),
        initialState,
        compose(applyMiddleware(...middleware), devToolsExtension)
    );

    return store;
}

function buildRootReducer(allReducers) {
    return combineReducers({
        ...allReducers
    });
}


